import React from 'react';

import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { navigate } from 'gatsby';
import { Trans, useTranslation } from 'react-i18next';

import { WheelsMap } from '../../features/wheels/components/wheels-map';

// ********************************************************************************
type Props = {};
export const WheelsBanner = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Box component="section" bgcolor="#F3F2F5" py={6}>
      <Container maxWidth="lg">
        <Box
          display="flex"
          gap="4em"
          justifyContent="space-between"
          flexDirection={{ xs: 'column', md: 'row' }}
        >
          <Stack spacing={3} justifyContent="center" maxWidth={{ xs: '100%', md: '600px' }}>
            <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
              {t('wheels_service.wheels_price.title')}
            </Typography>
            <Typography
              variant="body1"
              color="#302F2F"
              fontSize="18px"
              textAlign="left"
              lineHeight="20px"
              mt={2}
              maxWidth={{ xs: '100%', md: '488px' }}
            >
              <Trans i18nKey="wheels_service.wheels_price.description_1" />
            </Typography>
            <Typography
              variant="body1"
              color="#302F2F"
              fontSize="18px"
              textAlign="left"
              lineHeight="20px"
              mt={2}
              maxWidth={{ xs: '100%', md: '488px' }}
            >
              {t('wheels_service.wheels_price.description_2')}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                maxWidth: '233px',
              }}
              onClick={() => navigate('/#wheels')}
            >
              {t('wheels_service.wheels_price.button')}
            </Button>
          </Stack>
          <WheelsMap />
        </Box>
      </Container>
    </Box>
  );
};
